export function encodePollsData(data: any) {
  const dataString = JSON.stringify(data);
  return window.LZUTF8.compress(dataString, {
    outputEncoding: 'StorageBinaryString',
  });
}

export function decodePollsData(storageBinaryString: string) {
  const dataString = window.LZUTF8.decompress(storageBinaryString, {
    inputEncoding: 'StorageBinaryString',
  });

  return JSON.parse(dataString);
}

export async function getPollsByIdCard(t: any) {
  const pollsData = await t.get('card', 'shared', 'polls');

  if (!pollsData) {
    return [];
  }

  let polls: any;

  try {
    polls = decodePollsData(pollsData);
  } catch (e) {
    polls = pollsData;
  }

  return polls;
}

export async function setPollsByIdCard(t: any, polls: any) {
  const pollsData = encodePollsData(polls);

  return t.set('card', 'shared', 'polls', pollsData);
}

export async function addPollToCard(t: any, poll: any) {
  const polls = (await getPollsByIdCard(t)) || [];
  polls.push(poll);
  await setPollsByIdCard(t, polls);
  await addToRecentPolls(t, poll);
}

export async function getRecentPolls(t: any) {
  const recentPollsData = await t.get('board', 'shared', 'recentPolls');

  if (!recentPollsData) {
    return [];
  }

  let recentPolls: any;

  try {
    recentPolls = decodePollsData(recentPollsData);
  } catch (e) {
    recentPolls = recentPollsData;
  }

  return recentPolls;
}

export async function addToRecentPolls(t: any, poll: any) {
  const recentPolls = await getRecentPolls(t);

  const pollIndex = recentPolls.findIndex((p: any) => p.name === poll.name);
  if (pollIndex !== -1) {
    recentPolls.splice(pollIndex, 1);
  }

  recentPolls.unshift(poll);

  await t.set('board', 'shared', 'recentPolls', encodePollsData(recentPolls));
}

export async function removePollFromRecentPollsList(t: any, pollName: string) {
  const recentPolls = await getRecentPolls(t);
  const pollIndex = recentPolls.findIndex((p: any) => p.name === pollName);
  if (pollIndex !== -1) {
    recentPolls.splice(pollIndex, 1);
  }

  await t.set('board', 'shared', 'recentPolls', encodePollsData(recentPolls));
}

export async function clearAllRecentPolls(t: any) {
  await t.set('board', 'shared', 'recentPolls', encodePollsData([]));
}
